export default "__VITE_ASSET__2FuY68T$__"